export const GET_TOWN_LIST = "category/GET_TOWN_LIST";
export const GET_TOWN_LIST_COMPLETED = "category/GET_TOWN_LIST_COMPLETED";
